import SHOP_MANAGE_API from './shopManage';
import TALENT_CRM_API from './talentCRM';
import TEAM_MANAGE_API from './teamManage';
import COOPERATION_PROGRESS from './cooperationProgress';
import CONTENT_LIBRAY from './contentLibray';
import ORDER from './order';
import SETTING from './setting';
import EXPROT from './export';
import SAMP_ORDER from './sampOrder'

const API_OBJECT = {
	...SHOP_MANAGE_API.Api,
	...TALENT_CRM_API.Api,
	...TEAM_MANAGE_API.Api,
	...COOPERATION_PROGRESS.Api,
	...CONTENT_LIBRAY.Api,
	...ORDER.Api,
	...SETTING.Api,
	...EXPROT.Api,
	...SAMP_ORDER.Api
};

export { API_OBJECT };
